import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { waLink, waMessageFor } from "@/config/site";
import { trackWhatsappClick } from "@/lib/analytics";
import { useDestinations } from "@/lib/content";

// Pick the destination context for the WhatsApp message based on the current route.
// Renders immediately with a generic message while destinations are still loading —
// this button must never disappear/flash, it's a persistent floating CTA.
const useContext = () => {
  const { pathname } = useLocation();
  const { data: DESTINATIONS } = useDestinations();
  const dest = (DESTINATIONS || []).find((d) => pathname.startsWith(d.path));
  if (dest) return dest.name;
  return "";
};

export const FloatingWhatsApp = () => {
  const context = useContext();
  const message = waMessageFor(context);
  return (
    <a
      href={waLink(message)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      onClick={() => trackWhatsappClick("floating-button")}
      aria-label="Chat with Deep Dive Trips on WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-whatsapp animate-ping opacity-40" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-whatsapp hover:bg-whatsapp-hover text-white shadow-2xl transition-transform group-hover:scale-110">
        <MessageCircle size={26} strokeWidth={2} />
      </span>
    </a>
  );
};
